import { Stack, StackProps, Chip } from '@mui/material'
import { DashBoardConditions } from '../types'

type DashBoardConditionChipsProps = {
  conditions: DashBoardConditions
  onDeleteCondition: (axisKey: string) => void
} & StackProps
export const DashBoardConditionChips = ({
  conditions,
  onDeleteCondition,
  ...others
}: DashBoardConditionChipsProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      alignItems="center"
      useFlexGap
      {...others}
    >
      {Object.keys(conditions).map((axisKey, i) => {
        const condition = conditions[axisKey]
        const label = condition.label + (
          condition.over ? condition.not ? '未満' : '以上' : 
          condition.under ? condition.not ? 'より上' : '以下' : 
          condition.not ? '以外' : '')
        return (
          <Chip
            key={`dashboard-condition-${i}-${axisKey}`}
            label={label}
            variant="outlined"
            onDelete={() => {
              onDeleteCondition(axisKey)
            }}
          />
        )
      })}
    </Stack>
  )
}
